import { useEffect } from "react";
import "../assets/styles/chatLoader.css";

const loadScript = (id, src, attrs = {}) =>
  new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const s = document.createElement("script");
    s.id = id;
    s.src = src;
    s.async = true;
    Object.entries(attrs).forEach(([k, v]) => {
      if (v != null) s.setAttribute(k, v);
    });
    s.onload = () => resolve();
    s.onerror = (e) => reject(e);
    document.body.appendChild(s);
  });

export default function ChatLoader() {
  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        // Carrega jQuery primeiro (sem SRI para evitar bloqueio por mismatch)
        await loadScript(
          "jquery-core",
          "https://code.jquery.com/jquery-3.7.1.min.js"
        );
        if (cancelled) return;

        // Garante que window.jQuery esteja disponível
        if (!window.jQuery && !window.$) {
          console.warn("jQuery não disponível após carregamento.");
        }

        // Carrega o chat script em seguida
        await loadScript(
          "chatscript",
          "https://in.bot/api/inbot.gz.js?bot_id=1160&bot_token=1svhmc55ll&bot_server_type=production",
          { async: "true" }
        );
      } catch (err) {
        console.error("Falha ao carregar chat:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
